"use client";

import { useEffect } from "react";
import Script from "next/script";

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

function updateConsent(type: "all" | "necessary") {
  if (typeof window === "undefined" || !window.gtag) return;
  if (type === "all") {
    window.gtag("consent", "update", {
      analytics_storage: "granted",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  } else {
    window.gtag("consent", "update", {
      analytics_storage: "denied",
      ad_storage: "denied",
      ad_user_data: "denied",
      ad_personalization: "denied",
    });
  }
}

export default function GoogleTagManager() {
  useEffect(() => {
    // Consent für bereits getroffene Entscheidung (Page Reload) setzen
    const existing = localStorage.getItem("cookie-consent") as
      | "all"
      | "necessary"
      | null;
    if (existing) {
      updateConsent(existing);
    }

    // Auf neue Consent-Entscheidungen hören
    function handleConsentUpdate(e: Event) {
      const detail = (e as CustomEvent<{ type: "all" | "necessary" }>).detail;
      updateConsent(detail.type);
    }
    window.addEventListener("consentUpdated", handleConsentUpdate);
    return () => {
      window.removeEventListener("consentUpdated", handleConsentUpdate);
    };
  }, []);

  if (!GTM_ID) return null;

  return (
    <>
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`}
      />
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
          title="Google Tag Manager"
        />
      </noscript>
    </>
  );
}
